export const DATA_TRANSLATION_ATTRIBUTE = 'i18n-translation'
